import React, {FC, forwardRef} from "react"
import {Select, SelectInnerWrapper} from "./styles"
import {ErrorSpan, FieldWrapper, HelperText, Mewozlabel, Label} from "../styles"
import {SelectFieldProps} from "./types"
import ArrowDown from "@icons/ArrowDown"

const SelectField: FC<SelectFieldProps> = forwardRef<HTMLSelectElement, SelectFieldProps>(({
    label,
    required,
    error,
    options,
    marginClass,
    isLoading,
    isDisabled,
    helperText,
    helperTextNode,
    mewozLabel,
    ...props
}, ref) => {

    return <div>
        {mewozLabel && <Mewozlabel>{mewozLabel}</Mewozlabel>}
        {label && <Label className={"bold"}>{label}</Label>}
        <FieldWrapper>
            <SelectInnerWrapper>
                <Select hasError={!!error} isDisabled={!!isLoading || !!isDisabled} ref={ref} {...props}>
                    {options.map((option, index) =>
                        <option key={index} value={option.value}>{option.label}</option>,
                    )}
                </Select>
                <ArrowDown/>
            </SelectInnerWrapper>
        </FieldWrapper>
        {helperText && <HelperText>{helperText}</HelperText>}
        {error && <ErrorSpan>{error}</ErrorSpan>}
    </div>
})

export default SelectField
